import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for decoded itso messages
 */
export class DecodedItsoMessageService {
  private resource: InterACT.Interfaces.IResource<InterACT.Interfaces.ItsoMessages.DecodedItsoMessageResponse>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/decoded-itso-messages/:id');
  }

  /**
   * Function to create a decoded itso message
   *
   * @param decodedItsoMessage An object representation of a decoded itso message
   * @returns A promise that resolves when the create operation is completed
   */
  public create(decodedItsoMessage: InterACT.Interfaces.ItsoMessages.DecodedItsoMessage) {
    return this.resource.save(decodedItsoMessage).$promise;
  }

  /**
 * Retrieves a single decoded Itso Message using the supplied id
 * @param decodedItsoMessageId the id of the decoded Itso Message to retrieve
 * @return a promise that resolves with the decoded Itso Message when the operation is complete
 */
  public get(decodedItsoMessageId: string): ng.IPromise<InterACT.Interfaces.ItsoMessages.DecodedItsoMessageResponse> {
    return this.resource.get({ id: decodedItsoMessageId }).$promise;
  }
}
